import React from "react";
import PropTypes from "prop-types";
import "./TeamModalHeader.scss";

const TeamModalHeader = ({ title = "", description = "" }) => {
    const display =
        (title && title.length > 0) || (description && description.length > 0);
    return (
        display && (
            <div className="col col--12 team-modal-header -margin-bottom--15">
                {title && <h1>{title}</h1>}
                {description && <p>{description}</p>}
            </div>
        )
    );
};

TeamModalHeader.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
};

export default TeamModalHeader;
